import { P2GBox } from '@parcel2go/core-ui';
import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import { P2GDate } from '@parcel2go/core-ui';
import { useMemo } from 'react';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import ItemTag from '../item/ItemTag';
import { CountryCache, GenCountryKey } from '../../../lib/cache/CountryCache';
import { GetOrderReferencesStr } from '../item/OrderReferenceNumberUtils';
import { AppCard } from '~/components/card/app-card';
import ECommerceLogo from '~/apps/account-linking/components/ECommerceLogo';

interface props {
  toggle: () => void;
  selected: boolean;
  item: SmartSendItemApiModel;
  isXs: boolean;
}

export const RestoreItemRow: React.FC<props> = (props) => {
  const refs = useMemo(() => GetOrderReferencesStr(props.item), [props.item]);
  return (
    <AppCard>
      <P2GBox textAlign="left" p={2}>
        <P2GGrid container wrap="nowrap">
          <P2GGrid item flexGrow={1}>
            <P2GCheckBoxLegacy
              checked={props.selected}
              onChange={props.toggle}
              id={props.item.Id}
              label={
                <P2GBox>
                  <P2GGrid container spacing={1} direction="column">
                    <P2GGrid item>
                      <P2GText component="p">
                        <b>{props.item.Recipient.Name}</b>{' '}
                      </P2GText>
                      <P2GText component="p" variant="body2">
                        {props.item.Recipient.Postcode},{' '}
                        {CountryCache[GenCountryKey(props.item.Recipient)]?.LocalisedName}
                      </P2GText>
                      {props.item.Recipient.Email && (
                        <P2GText component="p" variant="body2">
                          {props.item.Recipient.Email}
                        </P2GText>
                      )}
                    </P2GGrid>
                    <P2GGrid item>
                      <P2GText component="p">
                        <b>{props.item.Description}</b>
                      </P2GText>
                      {refs && (
                        <P2GText component="p" variant="body2">
                          <i>{refs}</i>
                        </P2GText>
                      )}
                    </P2GGrid>
                    <P2GGrid item>
                      <P2GGrid container spacing={1} alignContent="center" alignItems="center">
                        <P2GGrid item>
                          <ItemTag tag={props.item.Source.Name} />
                        </P2GGrid>
                        <P2GGrid item>
                          <P2GDate variant="body2" date={props.item.Created} />
                        </P2GGrid>
                      </P2GGrid>
                    </P2GGrid>
                  </P2GGrid>
                </P2GBox>
              }
              labelPlacement="end"
              variant="primary"
              error={false}
            />
          </P2GGrid>
          {!props.isXs && (
            <P2GGrid item flexShrink={1}>
              <ECommerceLogo integration={props.item.Source.Id} style={{ width: '120px' }} />
            </P2GGrid>
          )}
        </P2GGrid>
      </P2GBox>
    </AppCard>
  );
};
